import proxy from 'httpClient/requests';
import { urlBuilder } from 'httpClient/aws/getAwsEndpoint';
import setTripxCacheKey from 'httpClient/aws/headers/setTripxCacheKey';
import HttpClient from 'httpClient';

/**
 * Search payment options.
 * https://apidocs.tripx.se/tripx-web-api#operation/POST_payment_options
 * @param {object} body - `/v2/payment_options` parameters.
 */
export function searchPaymentOptions(body) {
  return proxy({
    httpMethod: 'POST',
    timeout: 20,
    version: 2,
    apiMethod: 'payment_options_components',
    body,
  });
}

export function searchPartialPaymentOptions(body) {
  return proxy({
    httpMethod: 'POST',
    timeout: 20,
    version: 2,
    apiMethod: '/partial_payment_options_components',
    body,
  });
}

export function validatePromotionCode(body) {
  return proxy({
    httpMethod: 'POST',
    timeout: 5,
    version: 2,
    apiMethod: 'validate_promo',
    body,
  });
}

export function customerByPno(body) {
  return proxy({
    httpMethod: 'GET',
    timeout: 10,
    version: 1,
    apiMethod: 'customers/address_by_pno',
    body,
  });
}

const methodProxyCache = '/pc';
const paymentsMethod = '/payments/allowedPaymentOptions';

export function allowedPaymentOptions(websiteId) {
  const config = { headers: setTripxCacheKey({ method: paymentsMethod, websiteId }) };
  const url = urlBuilder({ method: methodProxyCache, queryParam: null });

  return HttpClient.post(url, { httpMethod: 'GET', timeout: 10, version: 3, apiMethod: paymentsMethod }, config);
}
